module.exports = __webpack_public_path__ + "45cbd10e273b7181bc3afe0f8828188c.jpg";